var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('button',{staticClass:"cell",class:[_vm.display,{pressed: _vm.pressed,flag: _vm.flag,fixed: _vm.fixed,triggerDead: _vm.triggerDead,question: _vm.question}]})}
var staticRenderFns = []

export { render, staticRenderFns }